import { useLocation } from "react-router-dom";
import { MainLink } from "../Menu";
import { version } from "../../../package.json";

function NavigationMenu({ loggedIn, permissions, accounts }) {
  const location = useLocation();
  const path = location.pathname;

  if (!loggedIn) return null;

  const {
    cashSales,
    reports,
  } = permissions;

  return (
    <div className="sub-nav">
      <nav>
        <ul>
          <li className={path === "/" ? "active" : ""}>
            <MainLink title="Dashboard" icon="fa-home" url="/" />
          </li>
          {cashSales && (
            <li
              className={
                path === "/orders" || path.indexOf("orders/") > -1
                  ? "active"
                  : ""
              }
            >
              <MainLink title="Cash Sales" icon="fa-tags" url="/orders" />
            </li>
          )}
          {reports && (
            <li
              className={
                path === "/reports" || path.indexOf("reports/") > -1
                  ? "active"
                  : ""
              }
            >
              <MainLink title="Reports" icon="fa-users" url="/reports" />
            </li>
          )}
        </ul>
      </nav>

      <div className="sub-nav-version">Version: {version}</div>
      <div className="sub-nav-text">
        {accounts.length > 0 && accounts[0].name}
      </div>
    </div>
  );
}

export default NavigationMenu;
